import React from 'react'
import Career from '../Career'
import Footer from '../footer/Footer'
import NavigationBar from '../nav/NavigationBar'

function CareerPage() {
  return (
    <div>
    <NavigationBar />
      <Career />
      <Footer />
    </div>
  )
}

export default CareerPage